"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var createId = function createId(baseFrequency, scaleNoise) {
  return function (i) {
    return "squiggly__filter-".concat(i, "--").concat(baseFrequency, "-").concat(scaleNoise);
  };
};
var _default = function _default(COUNT_OF_FILTERS, _ref) {
  var baseFrequency = _ref.baseFrequency,
    scaleNoise = _ref.scaleNoise;
  return (0, _react.useMemo)(function () {
    var createIdBaseOnProps = createId(baseFrequency, scaleNoise);
    return COUNT_OF_FILTERS.map(createIdBaseOnProps);
  }, [baseFrequency, scaleNoise]);
};
exports.default = _default;